import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand from './CategoryCommand';

class WatchCommand extends CategoryCommand<void> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.WATCH,
    };
  }

  public getIcon(): IconName {
    return 'watch';
  }
}

export default WatchCommand;
